import React from "react";
import { SampleRequestListPage } from "../../SharedPages/SampleRequestListPage/SampleRequestListPage";

export const BuyerSampleRequests = () => {
  return <SampleRequestListPage />;
};
